<h3 mat-dialog-title class="crop-modal-title d-none">
  {{ title }}
  <!-- <button mat-dialog-close class="close-button">
    <span class="close-icon">×</span>
  </button> -->
</h3>

<mat-dialog-content class="crop-modal-content">
  <!-- Every crop uses the caller's fixed targetWidth:targetHeight ratio; no ratio choice. -->
  <div class="mt-4"></div>
  <div
    class="crop-container"
    #cropContainer
    [style.cursor]="cursor"
    (mousedown)="onMouseDown($event)"
    (mousemove)="onMouseMove($event)"
    (mouseup)="onMouseUp()"
    (mouseleave)="onMouseUp()"
  >
    <canvas #canvas class="crop-canvas"></canvas>
    <img #imageElement [src]="imageSrc" style="display: none" />
  </div>

  <div class="size-control w-90 mx-auto">
    <label class="size-label d-none">Logo size</label>
    <div class="slider-container">
      <div class="size-value text-start">{{ minSize }}%</div>
      <input
        matTooltip="{{ logoSize }}%"
        type="range"
        class="size-slider"
        [min]="minSize"
        [max]="maxSize"
        [(ngModel)]="logoSize"
        (input)="onSizeChange()"
      />
      <span class="size-value">{{ maxSize }}%</span>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions class="crop-modal-actions p-0 pt-3 pb-3 mt-4">
  <button
    class="btn btn-cancel btn-white border rounded-3 w-25 text-black-50 bg-white"
    (click)="onCancel()"
  >
    Cancel
  </button>
  <button class="btn btn-save btn-dark rounded-3 w-25" (click)="onSave()">Apply</button>
</mat-dialog-actions>
